export function FullPageSpinner({ label = "Loading" }: { label?: string }) {
  return (
    <div className="flex h-full min-h-screen flex-col items-center justify-center gap-4 bg-paper">
      <div
        className="size-6 animate-spin rounded-full border-2 border-rule border-t-accent"
        aria-hidden
      />
      <p className="text-sm text-ink-soft" role="status">
        {label}…
      </p>
    </div>
  );
}
